<template>
  <div class="card card-data">
    <div class="card-header">
      <nav class="navbar">
        <ul class="nav">
          <li
            class="nav-item tab-item"
            v-for="(tab, index) in tabs"
            :key="`${tab}_${index}`"
            @click="setActive(tab)"
          >
            <a
              class="nav-link"
              :class="{ active: $isset(currentTab) && currentTab.key === tab.key }"
              :href="`#${currentTab.key}`"
              >{{ tab.name }}</a
            >
          </li>
        </ul>
      </nav>
      <hr class="rounded mx-3" />
    </div>
    <div class="card-body data-load" :class="{ 'sk-loading': isLoading }">
      <sk-spinner v-if="isLoading"></sk-spinner>
      <slot name="data" :tab="currentTab"> </slot>
    </div>
  </div>
</template>

<script>
import { Tab, CARD_DATA_TAB_CHANGED } from "./index";
import { SkSpinner } from "@/components";

export default {
  name: "CardDataComponent",
  props: {
    tabs: {
      type: Array,
      required: true,
      validator: function (tabs) {
        for (let tab of tabs) {
          if (!(tab instanceof Tab)) {
            console.error("tabs should include only Tab instance");
            return false;
          }
          return true;
        }
      },
    },
    currentTabKey: {
      type: String,
      required: true,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    SkSpinner,
  },
  computed: {
    currentTab() {
      let tab = this.tabs.find((x) => x.key === this.currentTabKey);
      return this.$isset(tab) ? tab : this.tabs[0];
    },
  },
  methods: {
    setActive(tab) {
      this.$emit(CARD_DATA_TAB_CHANGED, tab);
    },
  },
};
</script>

<style lang="scss" scoped>
.card-data {
  border: 1px solid var(--portal-border);
  border-radius: 14px;
  background-color: var(--portal-surface);
  color: var(--portal-text);
  box-shadow: var(--portal-shadow-sm);

  & > .card-header {
    background-color: transparent;
    padding: 0;
    border-bottom: 0;
  }

  & > .card-header > .navbar {
    padding-bottom: 0;
  }

  & > .card-body {
    background: transparent;
    color: inherit;
  }

  .tab-item {
    & > a {
      color: var(--portal-text-muted);
      font-size: 16px;
      font-weight: 600;
      letter-spacing: 0;
      line-height: 19px;
    }

    & > a:hover {
      color: var(--portal-text);
      border-bottom-color: transparent;
    }

    & > .active {
      color: var(--portal-secondary);
      border-bottom: 3px solid var(--portal-secondary) !important;
    }
  }
}

hr.rounded {
  padding: 0;
  margin: -3px 0 0 0;
  height: 3px;
  border: 0;
  border-radius: 15.5px;
  background-color: var(--portal-border);
  opacity: 1;
}
</style>
